import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import {
	Button,
	Checkbox,
	Modal,
	RadioButtonCore,
	Textfield,
	Timepicker,
} from "../../../../components/core";
import { Editor } from "react-draft-wysiwyg";

export default function SendEmailModal({
	open = false,
	onClose,
	data = {
		open: false,
		subject: "",
		message: "",
		target: [],
		schedule: new Date(),
	},
	onSubmit,
	onChange,
	header = "Email Message Notification",
}) {
	const [confirmModal, setConfirmModal] = React.useState({ open: false });
	const [scheduleBlastingFlag, setScheduleBlastingFlag] = React.useState(false);
	const [dateModal, setDateModal] = useState(false)
	const [validation, setValidation] = React.useState({
		icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
		title: "",
		message: "",
		open: false,
	});

	const handleCheckFields = () => {
		if (scheduleBlastingFlag && (!data.schedule || !data.subject)) {
			setValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: "Submit Error",
				message: "Please complete all fields",
				open: true,
				actions: (
					<div className="w-full">
						<Button
							onClick={() => setValidation({ open: false })}
							value={"OK"}
							className={"p-2 w-full"}
						/>
					</div>
				),
			});
		}
		else if (!data.subject || !data.message) {
			console.log("Incomplete fields!");

			setValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: "Incomplete Data",
				message: "Please complete all the fields to send this message.",
				open: true,
				actions: (
					<div className="w-full">
						<Button
							onClick={() => setValidation({ open: false })}
							value={"OK"}
							className={"p-2 w-full"}
						/>
					</div>
				),
			});

		} else {
			setConfirmModal((prev) => ({ ...prev, open: true }))

			// return;
		}
	}

	const formatDate = (dateString) => {
		const options = { month: 'long', day: 'numeric', year: 'numeric' };
		const formattedDate = new Date(dateString).toLocaleDateString('en-US', options);
		return formattedDate;
	}

	const formatTime = (timeString) => {
		const options = { hour: 'numeric', minute: 'numeric', hour12: true };
		const formattedTime = new Date(`2000-01-01T${timeString}`).toLocaleTimeString('en-US', options);
		return formattedTime;
	}

	return (
		<div>
			<Dialog
				header={header}
				visible={open}
				style={{ width: "50vw" }}
				onHide={() => { onClose(); setScheduleBlastingFlag(false); }}
				closeOnEscape={false}
			>
				<div className="w-full h-12 flex gap-6 mb-4 bg-secondary-buttonHeaderGray px-2">
					<RadioButtonCore
						label="Send now"
						checked={scheduleBlastingFlag === false}
						onChange={(e) => {
							setScheduleBlastingFlag(false);
						}}
						className={"my-auto"}
					/>
					<div className="w-[70%] flex gap-2">
						<RadioButtonCore
							label="Schedule Blasting"
							checked={scheduleBlastingFlag === true}
							onChange={(e) => {
								setValidation({
									icon: `${process.env.PUBLIC_URL}/assets/images/warning.png`,
									title: "Warning",
									message:
										"Once a schedule blast is sent, editing is not possible. Do you want to proceed with the blasting?",
									open: true,
									actions: (
										<div className="flex gap-4 my-4">
											<Button
												className={"p-2 w-full"}
												value={"No"}
												onClick={() => setValidation({ open: false })}
											/>
											<Button
												className={"p-2 w-full"}
												value={"Yes"}
												onClick={() => {
													setValidation({ open: false });
													setScheduleBlastingFlag(true);
												}}
											/>
										</div>
									),
								});
							}}
							className={"my-auto"}
						/>
						{scheduleBlastingFlag && (
							<>
								<div className="grid grid-cols-2 items-center justify-center gap-3	">
									<Textfield
										type="date"
										value={data.schedule}
										onChange={onChange}
										min={new Date().toISOString().split("T")[0]}
										name="schedule"
									/>

									<Timepicker
										value={data.time}
										onChange={onChange}
										name="time"
									/>
								</div>

							</>
						)}
					</div>
				</div>
				<p>Subject</p>
				<Textfield
					classNameParent="pr-1 mb-10 -ml-2"
					placeholder={"Type here"}
					value={data.subject}
					onChange={onChange}
					name="subject"
				/>
				<Editor
					// editorState={EditorState.createEmpty()}
					spellCheck={true}
					editorClassName="border border-gray"
					placeholder="Enter message here..."
					value={data.message}
					onChange={(e) => {
						console.log(e.blocks);
						onChange({ target: { value: e.blocks[0].text, name: "message" } });
					}}
					name="message"
				/>
				<div className="flex flex-row mt-2">
					<Button
						value={"Cancel"}
						className={"w-40 h-8 mb-2 text-black"}
						onClick={() => { onClose(); setScheduleBlastingFlag(false); }}
					/>
					<div className="mr-5"></div>
					<Button
						value={"Send"}
						className={"w-40 h-8 mb-2 text-black"}
						onClick={() => {
							if (scheduleBlastingFlag) {
								if (data.schedule && data.time) {
									// setConfirmModal((prev) => ({ ...prev, open: true }))
									handleCheckFields();
								} else {
									setValidation({
										icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
										title: "Select Date and Time",
										message: "Please choose both date and time, or select 'Send now' instead.",
										open: true,
										actions: (<div className="gap-2 w-full mx-auto">
											<Button
												onClick={() => setValidation({ open: false })}
												value={"OK"}
												className={"p-2 w-full"}
											/>
										</div>)
									})
								}
							} else {
								handleCheckFields();
							}
						}}
					// onClick={() => {
					// setValidation({
					// 	icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
					// 	title: "Success",
					// 	message: "Email has been sent.",
					// 	open: true,
					// });
					// 	setisLoading(true);
					// 	console.log({
					// 		message: emailMessage,
					// 		subject: emailSubject,
					// 		operatorId: operatorId,
					// 		target: emailsList,
					// 	});
					// 	broadCastUsersAPI
					// 		.sendEmail({
					// 			message: emailMessage,
					// 			subject: emailSubject,
					// 			operatorId: operatorId,
					// 			target: emailsList,
					// 		})
					// 		.then((r) => {
					// 			console.log(r);
					// 			setisLoading(false);
					// 			setEmailVisible(false);
					// 			setValidation({
					// 				icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
					// 				title: "Success",
					// 				message: "Email has been sent.",
					// 				open: true,
					// 			});
					// 		});
					// }}
					/>
				</div>
			</Dialog>
			<Dialog
				visible={confirmModal.open}
				onHide={() => setConfirmModal((prev) => ({ ...prev, open: false }))}
				header={`This will send an email to ${data.target.length} ${data.target.length == 1 ? "user" : "users"}.`}
			>
				<div className="flex flex-row justify-end mr-5">
					<Button
						value={"CANCEL"}
						className={"w-40 h-8 mb-2 text-black"}
						onClick={() =>
							setConfirmModal((prev) => ({ ...prev, open: false }))
						}
					/>
					<div className="mr-5"></div>
					<Button
						value={"PROCEED"}
						className={"w-40 h-8 mb-2 text-black"}
						onClick={() => {
							setConfirmModal((prev) => ({ ...prev, open: false }))

							if (scheduleBlastingFlag) {
								setDateModal((prev) => ({ ...prev, open: true }))
							} else {
								if (data.message == "" || data.subject == "") {
									setValidation({
										icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
										title: "Incomplete Data",
										message: "Please complete all the fields to send this message.",
										open: true,
										actions: (<div className="gap-2 w-full mx-auto">
											<Button
												onClick={() => setValidation({ open: false })}
												value={"OK"}
												className={"p-2 w-full"}
											/>
										</div>)
									})
								} else {
									onSubmit();
								}
							}
						}}
					/>
				</div>
			</Dialog>

			<Dialog visible={dateModal.open && scheduleBlastingFlag}
				onHide={() => setDateModal((prev) => ({ ...prev, open: false }))}
				header={`This blast will be sent on ${formatDate(data.schedule)} at ${formatTime(data.time)}`} className="p-4">
				<div className="flex flex-row justify-center items-center mr-5">
					<Button
						value={"Cancel"}
						className={"w-40 h-8 mb-2 text-black"}
						onClick={() =>
							setDateModal((prev) => ({ ...prev, open: false }))
						}
					/>
					<div className="mr-5"></div>
					<Button
						value={"Confirm"}
						className={"w-40 h-8 mb-2 text-black"}
						onClick={() => {
							setDateModal((prev) => ({ ...prev, open: false }));

							if (data.message == "" || data.subject == "") {
								setValidation({
									icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
									title: "Incomplete Data",
									message: "Please complete all the fields to send this message.",
									open: true,
									actions: (<div className="gap-2 w-full mx-auto">
										<Button
											onClick={() => setValidation({ open: false })}
											value={"OK"}
											className={"p-2 w-full"}
										/>
									</div>)
								})
							} else {
								onSubmit();
							}
						}}
					/>
				</div>
			</Dialog>

			<Modal
				icon={validation.icon}
				title={validation.title}
				message={validation.message}
				open={validation.open}
				actions={validation.actions}
			/>
		</div>
	);
}
